export default __webpack_public_path__ + "static/media/lobby_second_image.54106078.jpg";